import React from 'react';
import { Swords } from 'lucide-react';

const ChallengeBanner = ({ challengeData }) => {
  if (!challengeData) return null;
  
  return (
    <div className="max-w-2xl mx-auto mb-4">
      <div className="bg-gradient-to-r from-orange-600/80 to-red-600/80 rounded-lg p-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Swords className="w-6 h-6 text-white" />
          <div>
            <p className="text-white font-bold text-sm">Challenge from {challengeData.challenger_name}!</p>
            <p className="text-orange-200 text-xs">Beat their score of {challengeData.score_to_beat} to win!</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-white font-bold text-lg">{challengeData.score_to_beat}</p>
          <p className="text-orange-200 text-xs">to beat</p>
        </div>
      </div>
    </div>
  );
};

export default ChallengeBanner;
